export default __webpack_public_path__ + "static/media/nav_image.d2f55336.svg";